/* eslint-disable @typescript-eslint/no-floating-promises */
import './support/styleLoaderEmbed';
import './polyfill/all';
import './support/filterConsoleWarnings';

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import autobind from 'class-autobind';

import { AppConfigProvider } from './AppConfig';
import { QueryProvider } from './api/QueryProvider';
import CrossFrameMessenger from './support/helpers/CrossFrameMessenger';
import DataStore from './support/DataStore';
import EmbedResizeSensor from './components/uiold/EmbedResizeSensor';

import { getInitialParams } from './support/InitialParams';
import isEmbeddedFrame from './support/isEmbeddedFrame';
import addStylesheet from './support/helpers/addStylesheet';
import isValidID from './support/shared/isValidID';

import MapEmbed from './components/Embed/MapEmbed';
import { ThemeProvider } from './core-ui';

const dataStore = DataStore.getInstance('app');
dataStore.set('entryPoint', 'embed');

const match =
  window.location.pathname.match(
    /^\/public\/([0-9a-z-]+)\/markets\/([0-9a-z]+)/,
  ) || [];
const accountID = match[1] ? String(match[1]).replace('-', ':') : '';
const marketID = String(match[2]);
if (!isValidID(accountID) || !isValidID(marketID)) {
  throw new Error('Invalid URI');
}

let isEmbedded = isEmbeddedFrame();
// This disables the dynamic frame resizing stuff and enables scroll.
if (!isEmbedded && document.documentElement) {
  document.documentElement.classList.add('full-screen');
}

dataStore.set('accountID', accountID);

type Props = ObjectOf<unknown>;
type State = {
  isFullScreen: boolean;
};

class App extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    autobind(this);
    this.state = {
      isFullScreen: !isEmbedded,
    };
  }

  render() {
    let notImplemented = () => {
      // eslint-disable-next-line no-console
      console.log(
        'Opening a dialog is not yet implemented for embeds without JavaScript enabled.',
      );
    };
    let onProfileSelect = isEmbedded
      ? CrossFrameMessenger.showProfile
      : notImplemented;
    return (
      <div>
        <EmbedResizeSensor isEnabled={isEmbedded} />
        <MapEmbed
          accountID={accountID}
          key={marketID}
          marketID={marketID}
          isFullScreen={this.state.isFullScreen}
          onFullScreenToggle={this._toggleFullScreen}
          onProfileSelect={onProfileSelect}
        />
      </div>
    );
  }

  _toggleFullScreen() {
    // Doesn't make sense to toggle full screen if we're not embedded
    if (!isEmbedded) {
      return;
    }
    let isFullScreen = !this.state.isFullScreen;
    CrossFrameMessenger.onFullScreenToggle(isFullScreen);
    this.setState({
      isFullScreen: isFullScreen,
    });
    if (document.documentElement) {
      document.documentElement.classList.toggle('full-screen', isFullScreen);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  let params = getInitialParams();
  if (typeof params.stylesheet === 'string') {
    addStylesheet(params.stylesheet);
  }
  let rootNode = document.createElement('div');
  if (document.body) {
    document.body.appendChild(rootNode);
  }
  ReactDOM.render(
    <QueryProvider>
      <AppConfigProvider>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </AppConfigProvider>
    </QueryProvider>,
    rootNode,
  );
});
